import React, { useEffect, useState } from "react";
import { getAppContent } from '../../api/apiHandler';
import { showErrorMessage } from "../common/Utils";
import HtmlContent from '../../components/htmlcontent/HtmlContent';

export function Termsofuse() {

    const divStyle = {
        backgroundColor: 'white',
        padding: '25px 25px',
        borderRadius: '8px',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
        textAlign: 'justify',
        lineHeight: '1.6',
        fontSize: '16px',
        color: '#333',
    };

    const [appContent, setAppContent] = useState({
        content_title: '',
        content_key: '',
        content_value: ''
    });
    
    useEffect(() => {
        async function getAppData() {
            const contentReq = {
                type: 'condition_content'
            }
            const response = await getAppContent(contentReq);
            if (parseInt(response.code) === 1) {
                setAppContent(response.data);
            } else {
                showErrorMessage(response.message);
            }
        }
        getAppData();
    }, []);

    return (
        <>
            <section className="">
                <div className="">
                    <div className="">
                        <div className="" style={divStyle}>
                            <HtmlContent html={appContent.content_value} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}